import { render, staticRenderFns } from "./CustomDonutChart.vue?vue&type=template&id=18d57b16&"
import script from "./CustomDonutChart.vue?vue&type=script&lang=js&"
export * from "./CustomDonutChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports